// extracted by mini-css-extract-plugin
module.exports = {"modal":"ModalAlert_modal__2TrHl","title":"ModalAlert_title__qFlZj","description":"ModalAlert_description__1lQcb"};